// extracted by mini-css-extract-plugin
export default {"gap":"UIPXOKGozpnLkmLE5W34"};